export const recipeMaterialDtoFields = [{
        name: "clfMaterialTypeDescription",
        title: "Materiale",
        render: (record) => record.clfMaterialTypeDescription
    }, {
        name: "quantity",
        title: "Quantità",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.recipeMaterial.quantity.toFixed(0)
    }];
